import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import type { Device } from "../device/device";
import { t } from "../locale";
import {
	sortedSetAdd,
	sortedSetDelete,
	sortedSetIncludes,
} from "../sorted_set";
import { materialSymbol } from "./material-symbol";
import { button, div, input, label, table, tbody, td, tr } from "./van-tags";

interface Shared {
	device: Device;
}

export const deviceSharingField = (shared: Shared): ChildDom => {
	const local = reactive({
		email: "",
	});

	const onClickInvite = (): void => {
		shared.device.Metadata.Access = sortedSetAdd(
			shared.device.Metadata.Access,
			local.email,
		);
		local.email = "";
	};

	const onInputEmail = (e: Event): void => {
		if (!(e.target instanceof HTMLInputElement)) return;
		local.email = e.target.value;
	};

	return div(
		{ class: "field" },
		label({ class: "label" }, t.device.settingsPage.sharingLabel),
		div(
			{ class: "field has-addons" },
			div(
				{ class: "control is-expanded" },
				input({
					class: "input",
					oninput: onInputEmail,
					placeholder: t.email,
					type: "email",
				}),
			),
			div(
				{ class: "control" },
				button(
					{
						class: "button is-primary",
						onclick: onClickInvite,
					},
					t.add,
				),
			),
		),
		table({ class: "table is-fullwidth" }, () =>
			tbody(
				shared.device.Metadata.Access.map((email) =>
					tr(
						td(email),
						toggleNotificationTableCell(shared, email),
						kickUserTableCell(shared, email),
					),
				),
			),
		),
	);
};

const kickUserTableCell = (shared: Shared, email: string): ChildDom => {
	const onClickKick = (email: string): void => {
		shared.device.Metadata.Access = sortedSetDelete(
			shared.device.Metadata.Access,
			email,
		);
	};

	return td(
		shared.device.Metadata.OwnerEmail === email
			? materialSymbol({
					id: "star",
				})
			: materialSymbol({
					id: "close",
					onclick: () => onClickKick(email),
				}),
	);
};

const toggleNotificationTableCell = (
	shared: Shared,
	email: string,
): ChildDom => {
	const onClickToggleOff = (email: string): void => {
		shared.device.Metadata.Notify = sortedSetDelete(
			shared.device.Metadata.Notify,
			email,
		);
	};

	const onClickToggleOn = (email: string): void => {
		shared.device.Metadata.Notify = sortedSetAdd(
			shared.device.Metadata.Notify,
			email,
		);
	};

	return td(
		sortedSetIncludes(shared.device.Metadata.Notify, email)
			? materialSymbol({
					id: "notifications",
					onclick: () => onClickToggleOff(email),
				})
			: materialSymbol({
					id: "notifications_off",
					onclick: () => onClickToggleOn(email),
				}),
	);
};
